import { AxiosPromise } from 'axios';
import axios from 'axios';
import QueryString from 'qs';

const uri = '/mgmt/toss-payment';
const serviceUri = '/service/toss-payment';

export const sendPaymentSuccessTodo = (query: any): AxiosPromise => {
  const qsParams = QueryString.stringify(query);
  return axios.get(`${serviceUri}/success-todo?${qsParams}`);
};

// legacy

export const handleRetirePayment = (classRetierCode: string): AxiosPromise => {
  return axios.put(`${uri}/${classRetierCode}`);
};
